import * as dateFns from 'date-fns';
import { shortDateFormat } from './constants';

/**
 * Formats a date string to a short date string
 * @param date - date string to format must be in yyyy-MM-dd format
 * @returns formatted date string using shortDateFormat
 */
export const formatDateToShortDate = (date: string): string => {
  if (!date) {
    return '';
  }

  try {
    const parsedDate = dateFns.parse(date, 'yyyy-MM-dd', new Date());
    const formattedDate = dateFns.format(parsedDate, shortDateFormat);

    return formattedDate;
  } catch (e) {
    return date;
  }
};
